const USA = 'Estados Unidos';
const URSS = 'URSS';
const INTERESTELAR = 'Espaço interestelar';

const Missions = [
  {
    name: 'Mariner 2',
    year: '1962',
    country: USA,
    destination: 'Vênus',
  },
  {
    name: 'Venera 4',
    year: '1967',
    country: URSS,
    destination: 'Vênus',
  },
  {
    name: 'Mariner 5',
    year: '1967',
    country: USA,
    destination: 'Vênus',
  },
  {
    name: 'Apollo 11',
    year: '1969',
    country: USA,
    destination: 'Lua',
  },
  {
    name: 'Mariner 10',
    year: '1973',
    country: USA,
    destination: 'Mercúrio e Vênus',
  },
  {
    name: 'Voyager 1',
    year: '1977',
    country: USA,
    destination: INTERESTELAR,
  },
  {
    name: 'Venera 16',
    year: '1983',
    country: URSS,
    destination: 'Vênus',
  },
  {
    name: 'Phobos 1',
    year: '1988',
    country: URSS,
    destination: 'Marte',
  },
  {
    name: 'Phobos 2',
    year: '1988',
    country: URSS,
    destination: 'Marte',
  },
  {
    name: 'Galileo',
    year: '1989',
    country: USA,
    destination: 'Júpiter',
  },
  {
    name: 'Mars Pathfinder',
    year: '1996',
    country: USA,
    destination: 'Marte',
  },
  {
    name: 'Cassini-Huygens',
    year: '1997',
    country: 'Estados Unidos e Europa',
    destination: 'Saturno',
  },
  {
    name: 'Nozomi (Planeta B)',
    year: '1998',
    country: 'Japão',
    destination: 'Marte',
  },
  {
    name: 'Estação Internacional Espacial',
    year: '1998',
    country: 'Estados Unidos e Rússia',
    destination: 'Órbita terrestre',
  },
  {
    name: 'Mars Polar Lander',
    year: '1999',
    country: USA,
    destination: 'Marte',
  },
  {
    name: '2001 Mars Odyssey',
    year: '2001',
    country: USA,
    destination: 'Marte',
  },
  {
    name: 'Genesis',
    year: '2001',
    country: USA,
    destination: 'Terra',
  },
  {
    name: 'MESSENGER',
    year: '2004',
    country: USA,
    destination: 'Mercúrio',
  },
  {
    name: 'Telescópio Espacial Kepler',
    year: '2009',
    country: USA,
    destination: INTERESTELAR,
  },
  {
    name: 'Telescópio Espacial James Webb',
    year: '2021',
    country: 'Estados Unidos, União Europeia e Canadá',
    destination: INTERESTELAR,
  },
];

export default Missions;
